import axios from "axios";
import { isPreview } from "../helpers/authHelper";
import { BE_SERVER_ENDPOINT, API_PROTOCOL } from "../constants/configs.js";
export const TREES_WIDGET_DATA_ACTIONS = {
    FETCH_TREES_WIDGET_DATA_SUCCESS: "FETCH_TREES_WIDGET_DATA_SUCCESS",
    FETCH_TREES_WIDGET_DATA_FAILED: "FETCH_TREES_WIDGET_DATA_FAILED"
};

export function treesDataFetcher(options, templateName) {
  let params = {
    "measurement-type": options.measurementType,
    "mode": options.mode,
    "start": options.start,
    "end": options.end
  };
  if(isPreview()){
    params.templateName = templateName;
  };
    return dispatch => {
      axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + "/v2.0/dashboard/users/" + options.userId + "/env-impact-widget-data", {
          params
      }).then(
        (response) => {
          dispatch({
            type: TREES_WIDGET_DATA_ACTIONS.FETCH_TREES_WIDGET_DATA_SUCCESS,
            payload: response.data.payload
          })
        },
        (error) =>{
          dispatch({
              type: TREES_WIDGET_DATA_ACTIONS.FETCH_TREES_WIDGET_DATA_FAILED,
              payload: error
          })
        }
      )
    };
};
